// extracted by mini-css-extract-plugin
module.exports = {"header":"OrdersetList_header__rz5yH","column":"OrdersetList_column__2JkyU","row":"OrdersetList_row__yYRb0","deleteIcon":"OrdersetList_deleteIcon__3hZYN"};